export default [
    {
        path: '/asignacion-permisos',
        name: 'manager.asignacion-permisos',
        component: () => import(/* webpackChunkName: "informacion" */ '../../pages/asignacionPermisos').then(m => m.default || m),
    }
]